import { render, staticRenderFns } from "./MutedPlayers.vue?vue&type=template&id=478e12fe&scoped=true&"
import script from "./MutedPlayers.vue?vue&type=script&lang=js&"
export * from "./MutedPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e12fe",
  null
  
)

export default component.exports